export default __webpack_public_path__ + "static/media/profile_mobile.766dc02e.svg";